import { IAjaxResponse, TokenService } from 'abp-ng2-module';
import { Component, Injector, OnInit } from '@angular/core';
import { AppConsts } from '@shared/AppConsts';
import { appModuleAnimation } from '@axilla/axilla-shared';
import { AppComponentBase } from '@shared/common/app-component-base';
import {
    TenantSettingsServiceProxy, OrderGuideSimpleDto, VDBServiceProxy, PagedResultDtoOfVirtualDbRowDto, VirtualDbRowDto,
} from '@shared/service-proxies/service-proxies';
import { FileUploader, FileUploaderOptions } from 'ng2-file-upload';
import { finalize } from 'rxjs/operators';
import * as _ from 'lodash-es';

import { WebshopService } from '../../shared/common/shop-system/services/webshop.service';

@Component({
    templateUrl: './configuration.component.html',
    styleUrls: ['./configuration.component.less'],
    animations: [appModuleAnimation()]
})
export class WebshopConfigurationComponent extends AppComponentBase implements OnInit {

    get ddOG(): any {
        return this._webshopService.ddOG;
    }

    get isOGAvailable(): boolean {
        return this._webshopService.isOGAvailable;
    }
    get ddOGBanner(): any {
        return this._ddOGBanner;
    }
    set ddOGBanner(value: any) {
        this._ddOGBanner = value;
    }

    constructor(
        injector: Injector,
        private _tenantSettingsService: TenantSettingsServiceProxy,
        private _tokenService: TokenService,
        private _webshopService: WebshopService,
        private _vdbServiceProxy: VDBServiceProxy,
    ) {
        super(injector);
    }

    selectedOg: OrderGuideSimpleDto;
    isBannerExist = false;
    selectedBanners: VirtualDbRowDto[] = [];

    private _ddOGBanner: any = [];

    selectedBanner: any;
    nextBannerNumber = 1;

    loading = false;

    bannerUploader: FileUploader;

    remoteServiceBaseUrl = AppConsts.remoteServiceBaseUrl;

    isDeleteDisabled(): boolean {
        if (this.selectedBanner) {
            return false;
        }

        return true;
    }

    ngOnInit(): void {

    }

    onSelectOg($event) {
        this._reset();

        if (this.selectedOg) {
            this.checkIfBannerExist();
        }
    }


    checkIfBannerExist() {
        this._vdbServiceProxy.getSearchVirtualDbRows(
                this.selectedOg.code,
                //"Configuration.Banners",
                'Configuration.Banner',
                undefined,
                undefined,
                undefined,
                false,
                undefined,
                0,
                1000
            )
            .subscribe((result: PagedResultDtoOfVirtualDbRowDto) => {

                if (result.totalCount > 0) {
                    this.isBannerExist = true;
                    this.selectedBanners = result.items;

                    this._initOGBannerDd();
                }

                this.nextBannerNumber = this._getNextBannerNumber();
                this.initUploaders();

            });
    }


    //#region Banner

    private _reset() {
        this.ddOGBanner = [];
        this.selectedBanners = [];
        this.selectedBanner = null;
        this.bannerUploader = null;
    }

    private _getNextBannerNumber() {
        let max = 1;
        if (!this.selectedBanners || this.selectedBanners.length === 0) {
            return max;
        }

        let arr = [];
        for (let i = 0; i < this.selectedBanners.length; i++) {
            let item = this.selectedBanners[i];
            let key = item.key;
            arr.push(key.split('_')[1]);
        }

        max = _.max(arr);
        return ++max;
    }

    private _initOGBannerDd() {
        this.ddOGBanner.unshift({
            label: this.l('Please select banner'),
            value: ''
        });

        _.each(this.selectedBanners,
            (banner: VirtualDbRowDto) => {
                this.ddOGBanner.push({
                    label: banner.key,
                    value: banner.key
                });
            });
    }

    onBannerSelect($event) {
        console.log(this.selectedOg);

    }

    //#endregion Banner



    initUploaders(): void {
        this.bannerUploader = this.createUploader(
            '/TenantCustomization/UploadBanner',
            result => {
                console.log(result);
            }
        );
    }

    createUploader(url: string, success?: (result: any) => void): FileUploader {
        const uploader = new FileUploader({
            url: AppConsts.remoteServiceBaseUrl + url,
            method: 'POST',
            additionalParameter: {
                ogId: this.selectedOg.id,
                ogName: this.selectedOg.name,
                ogCode: this.selectedOg.code,
                pictureNumber: this.nextBannerNumber
            }
        });

        uploader.onAfterAddingFile = (file) => {
            file.withCredentials = false;
        };

        uploader.onSuccessItem = (item, response, status) => {
            const ajaxResponse = <IAjaxResponse>JSON.parse(response);
            if (ajaxResponse.success) {
                this.notify.info(this.l('SavedSuccessfully'));
                if (success) {
                    success(ajaxResponse.result);
                }
            } else {
                this.message.error(ajaxResponse.error.message);
            }
        };

        let uploaderOptions = {
            method: 'POST',
            authToken: 'Bearer ' + this._tokenService.getToken(),
            removeAfterUpload: true
        };
        uploader.setOptions(uploaderOptions as FileUploaderOptions);
        return uploader;
    }

    uploadBanner(): void {
        this.bannerUploader.uploadAll();
    }



    clearBanner(): void {

        if (this.selectedBanner) {

            let message = this.localization.localize('Axilla.App.Webshop.DeleteBannerMessage', 'Axilla');
            let title = this.localization.localize('Axilla.App.Webshop.DeleteBannerTitle', 'Axilla');
            abp.message.confirm(message, title, (isConfirmed) => {
                if (isConfirmed) {
                    const bannerVdbName = 'Configuration.Banner';
                    const bannerImageVdbName = 'Configuration.Banner.Images';

                    this._vdbServiceProxy
                        .deleteVirtualDbKey(bannerVdbName, this.selectedBanner)
                        .subscribe(() => {
                            this._vdbServiceProxy
                                .deleteVirtualDbKey(bannerImageVdbName, this.selectedBanner)
                                .subscribe(() => {
                                    abp.notify.success('The banner was successfully deleted');
                                });
                        });
                }
            });


        }
    }
}
